module.exports = __webpack_public_path__ + "static/img/14010103.90410fce.png";